/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sd-bridge-summary-report[_ngcontent-%COMP%]{display:block;width:100%;padding:0;margin:0}.sd-bridge-summary-report[_ngcontent-%COMP%]   .bridgeSummaryTable[_ngcontent-%COMP%]{width:95%;margin-left:auto;margin-right:auto}.sd-bridge-summary-report[_ngcontent-%COMP%]   .bridgeSummaryTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{color:#fff;background-color:#20324f;text-align:center}.sd-bridge-summary-report[_ngcontent-%COMP%]   .bridgeSummaryTableSection[_ngcontent-%COMP%]{width:100%}"];
export { styles as styles };
